import {Injectable} from '@angular/core';
import { Http, Response, Headers } from '@angular/http';
import {Product, Brand} from '../classes/product';
import {BehaviorSubject, Observable, Subject, Subscriber} from 'rxjs';
import { Body } from '@angular/http/src/body';
import { map } from 'rxjs/operators';
import { Component, OnInit, Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
@Injectable()
export class CommonService {
  pet = 0;
  ustatus = 0;
  category = 0;
  categoryid: BehaviorSubject<number> = new BehaviorSubject<number>(this.category);
  imagepath = 'avatar-1577909_960_720.png';
  public data: Brand[];
  rid = 1;
  gdata: any;
  gjson: any;
  uid: any;
  uname: any;
  uemail: any;
  umobile: any;
  tflag: number;
  eflag: number;
  mfstatus = 0;
  position = 0.0;
  doctorname = 'na';
  private interserviceUrls = {
    base: "https://petcart.in:8085",
    userEntry: "/v1/user-entries/",
    liveChannel: "/v1/live-channels/"
}
  public loginsuccess = new BehaviorSubject<number>(this.mfstatus);
  loginsuccessvalue = this.loginsuccess.asObservable();
  private menuflagstatus = new BehaviorSubject<number>(this.mfstatus);
  menuflag = this.menuflagstatus.asObservable();
  private nestmenuflagstatus = new BehaviorSubject<number>(this.mfstatus);
  nestmenuflag = this.nestmenuflagstatus.asObservable();
  private pulsemenuflagstatus = new BehaviorSubject<number>(this.mfstatus);
  pulsemenuflag = this.pulsemenuflagstatus.asObservable();
  public specialisationfilter = new BehaviorSubject<number>(this.mfstatus);
  specializationfilterid = this.specialisationfilter.asObservable();
  public latitude = new BehaviorSubject<number>(this.position);
  lat = this.latitude.asObservable();
  public longitude = new BehaviorSubject<number>(this.position);
  lon = this.longitude.asObservable();
  public geosetflag = new BehaviorSubject<number>(this.mfstatus);
  geosetflagvalue = this.geosetflag.asObservable();
  public doctornameflag = new BehaviorSubject<string>(this.doctorname);
  doctornameflagvalue = this.doctornameflag.asObservable();
  public petflag = new BehaviorSubject<number>(this.pet);
  petflagvalue = this.petflag.asObservable();
  private cdtk= "eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiIsImp0aSI6IjZlOWVlZDVjODQ5Yzk1YTVlNjIwYTUyMDMwMTYyMDJiOTBmYzAxNzRkMzA3NDc0OTc1ZmFlMDgyNDdkMGNhNjdiNmFhMzIzM2NmMjgyYjA0In0.eyJhdWQiOiIzIiwianRpIjoiNmU5ZWVkNWM4NDljOTVhNWU2MjBhNTIwMzAxNjIwMmI5MGZjMDE3NGQzMDc0NzQ5NzVmYWUwODI0N2QwY2E2N2I2YWEzMjMzY2YyODJiMDQiLCJpYXQiOjE1MzE0MDA3MjcsIm5iZiI6MTUzMTQwMDcyNywiZXhwIjoxNTYyOTM2NzI3LCJzdWIiOiIiLCJzY29wZXMiOltdfQ.dz0LSq7-jtxzrLmH6KgrNFGBYYq7UHf9n10owKt1JSoUdoLiCJJEmTprHufPiBrzu_6FxwivAUW5gD6yCQicAeVvxqBk1V3lNJduKt8TrCqeJWhqlECRvPp-fRJsbh3ZxsPwysKrAlb2AeWBv_NowO7nRyB4IpUiTatmV_Ud41WdM_pW-hBdJGLlX8-m5wHRYGOyMQay257byTtqOtJHVpouZd8b3Itta2uVX4cVaGgtTosebKfuLYG_xs5yLGMXXuab8pL2e5IdhYsYe1WJ0n-1qUK0ZH26WyLBZzEQ7s7DR3HGJN_YfBRLEDRmphvnYxBeAfiKtl1G4ztFSOksG5Qwxq-YugCODot_AmiNvUVxqRumgzegyx-xJN-Xc7ATbghFQ9iJwpLRiiqbQrFtsAe8eB6dLMpQ-mV4wFqZp51EQtAViW0LL9Rb9z1pghaMhBdurNyKCr5r-dMgI8fPAUd5iEQ8lloz-BJ_dowSiotHiPMNgpQOuQ_3lMKZyWs9UGxyCzCJ5g52Pe28Qvd8KLZ5uyI6pOQZNBRHGD0QRjn9erW3tDGDWx-Teba77YiLlpGjpX9zxbruEun0n3BlorGX7QEncW9riLorDC8OnWPNvgL1Iu1d1sEYYFKdfJETfrBCcrDWjexHWtbBtZZEthztq1wPiqbtOw5INiTjV6Q";
  clientcredentialheader = new Headers({'Content-Type':'application/json',
  'Accept':'application/json', 'X-Requested-With': 'XMLHttpRequest',
  'Authorization': this.getClientCredential()});
   authcredheader: any;
 constructor(private http: Http,@Inject(PLATFORM_ID) private platformId: Object) {
   this.ustatus = 0;
 }

 getClientCredential(){
  var Bearer= 'Bearer' + ' ' + this.cdtk;
  return Bearer;
}
getAuthCredential(){
  if (isPlatformBrowser(this.platformId)) {
  var a = localStorage.getItem("token");
  var tjson =JSON.parse(a);
  if(tjson != null){
    var auth= 'Bearer' + ' ' +  tjson.token;
    return auth;
  }
}
}

genAuthHeader(){
  this.authcredheader = new Headers({'Content-Type':'application/json',
  'Accept':'application/json',
  'Authorization': this.getAuthCredential()})
}


setMenuFlag(stat) {
  this.menuflagstatus.next(stat);
}
setPulseMenuFlag(stat) {
  this.pulsemenuflagstatus.next(stat);
}
setNestMenuFlag(stat) {
  this.nestmenuflagstatus.next(stat);
}
getBrands() {
    return this.http.get('https://passport.petcart.in/brands',
    {headers: this.clientcredentialheader})
    .pipe(map(
      (response: Response) => {
      return response.json().data;
      })
    );
  }
 getFlavours() {
    return this.http.get('https://passport.petcart.in/flavours',
    {headers: this.clientcredentialheader})
    .pipe(map(
      (response: Response) => {
       return response.json().data;
      })
    );
  }

  /* getInventory() {
    return this.http.get('https://passport.petcart.in/inventory')
    .pipe(map(
      (response: Response) => {
       return response.json().data;
      })
    );
  }*/

  getInventoryDetail(id: number) {
    return this.http.get('https://passport.petcart.in/invcheck?product_id=' + id ,
    {headers: this.clientcredentialheader} )
    .pipe(map(
      (response: Response) => {
        return response.json().data;
      })
    );
  }

  getInventoryDetails(id: number, city_id: number) {
    return this.http.get('https://passport.petcart.in/invcheck?product_id=' + id + ' &city_id=' + city_id,
    {headers: this.clientcredentialheader} )
    .pipe(map(
      (response: Response) => {
        return response.json().data;
      })
    );
  }

  /*getInventories(id, city_id, store_id) {
    return this.http.get('https://passport.petcart.in/inventory?product_id='+ id +'&city_id='+ city_id +'&store_id='+ store_id)
    .pipe(map(
      (response: Response) => {
        return response.json().data;
      }
    );
  }*/


  getCityInventoryDetails( city_id: number) {
    return this.http.get('https://passport.petcart.in/invcheck?city_id=' + city_id,
    {headers: this.clientcredentialheader} )
    .pipe(map(
      (response: Response) => {
        return response.json().data;
      })
    );
  }

getLifestages() {
    return this.http.get('https://passport.petcart.in/lifestages',
    {headers: this.clientcredentialheader})
    .pipe(map(
      (response: Response) => {
        return response.json().data;
      })
    );
  }
  getCategories() {
    return this.http.get('https://passport.petcart.in/categories',
    {headers: this.clientcredentialheader})
   .pipe(map(
    (response: Response) => {
      return response.json().data;
    })
  );
}
changeProductCategory(id) {
     return this.http.get('https://passport.petcart.in/catprods?category_id=' + id,
     {headers: this.clientcredentialheader})
   .pipe(map(
    (response: Response) => {

      return response.json().data;
    })
  );

}

/*updateInventory(id, astock, sstock){
  return this.http.put('https://passport.petcart.in/inventory/' + id,
  { actualstock: astock,storestock:sstock})
 .pipe(map(
   (response: Response) => {
     return response.json().data;
   }
 );
}*/
updateStockWithStatus(id: number , astock: number, tstock: number, status: number) {
  this.genAuthHeader();
     return this.http.put('https://passport.petcart.in/invcheck/' + id,
       { actualstock: astock, totalstock: tstock, status: status},
       {headers: this.authcredheader})
      .pipe(map(
        (response: Response) => {
          return response.json().data;
        })
      );
   }

   updateStockWithoutStatus(id: number, astock: number, tstock: number) {
     this.genAuthHeader();
    return this.http.put('https://passport.petcart.in/invcheck/' + id,
      { actualstock: astock, totalstock: tstock}, {headers: this.authcredheader})
     .pipe(map(
       (response: Response) => {
         return response.json().data;
       })
     );
  }


updateStock(id: number, status: number) {
  this.genAuthHeader();
  return this.http.put('https://passport.petcart.in/invcheck/' + id,
    {status: status},
    {headers: this.authcredheader})
   .pipe(map(
     (response: Response) => {
       return response.json().data;
     })
   );
}

checkUserdataLocally() {
  this.tflag = this.checkTemporaryUser();
  this.eflag = this.checkExistingUser();
  if (this.tflag === 0 && this.eflag === 0) {
    this.createTemporaryUser();
    return 'temp';
  }
  if (this.tflag === 1 && this.eflag === 0) {
    return 'temp';
  }
  if (this.tflag === 0 && this.eflag === 1) {
    return 'exist';
  }
}
checkTemporaryUser() {
  if (isPlatformBrowser(this.platformId)) {
  const gdata = localStorage.getItem('idata');
  const gjson = JSON.parse(gdata);
  if (gjson != null) {
    return 1;
  } else {
    return 0;
  }
}
}
checkExistingUser() {
  if (isPlatformBrowser(this.platformId)) {
  const gdata = localStorage.getItem('currentUser');
  const gjson = JSON.parse(gdata);
  if (gjson != null) {
    return 1;
  } else {
    return 0;
  }
}
}
getUserDataLocally() {
  if (isPlatformBrowser(this.platformId)) {
  const checkuserflag = this.checkUserdataLocally();
  if (checkuserflag === 'temp') {
    this.gdata = localStorage.getItem('idata');
    this.gjson = JSON.parse(this.gdata);
      this.gjson = JSON.parse(this.gdata);
      this.uid = this.gjson.uid;
      this.uname = this.gjson.uname;
      this.uemail = this.gjson.uemail;
      this.umobile = this.gjson.umobile;
      return {uid:  this.uid, uname: this.uname, uemail: this.uemail, umobile: this.umobile };
    } else {
      this.gdata = localStorage.getItem('currentUser');
      this.gjson = JSON.parse(this.gdata);
        this.gjson = JSON.parse(this.gdata);
        this.uid = this.gjson.uid;
        this.uname = this.gjson.uname;
        this.uemail = this.gjson.uemail;
        this.umobile = this.gjson.umobile;
        this.ustatus = 1;
        return {uid:  this.uid, uname: this.uname, uemail: this.uemail, umobile: this.umobile };
 }
}
}
checkUserStatus() {
  if (isPlatformBrowser(this.platformId)) {
  if (localStorage.getItem('token')) {
    this.ustatus = 1;
  }else {
    this. ustatus = 0;
  }
  return this.ustatus;
}
 }
 setuserStatus() {
  this.ustatus = 0;
 }
createTemporaryUser() {
  if (isPlatformBrowser(this.platformId)) {
  const uid = this.getRandomInt();
  const uname = this.uid + this.randomString();
  localStorage.setItem('idata', JSON.stringify({ uid: uid, uname: uname, umobile: '56565656',
   uemail: 'guest@gmail.com' }));
  }
}
getRandomInt() {
  return Math.floor(Math.random() * (20000 - 5 + 1)) + 5;
}
randomString() {
  const chars = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXTZabcdefghiklmnopqrstuvwxyz';
  const string_length = 5;
  let randomstring = '';
  for (let  i = 0; i < string_length; i++) {
    const rnum = Math.floor(Math.random() * chars.length);
    randomstring += chars.substring(rnum, rnum + 1);
  }
  return randomstring;
}

logout(): void {
  if (isPlatformBrowser(this.platformId)) {
        // clear token remove user from local storage to log user out
       localStorage.removeItem('currentUser');
  }
    }
    getCityinventory(city_id: number) {
      return this.http.get('https://passport.petcart.in/invcheck?city_id=' + city_id,
      {headers: this.clientcredentialheader})
      .pipe(map(
        (response: Response) => {
          return response.json().data;
        })
      );
    }

    getProducts(): Observable<any> {
      return this.http.get('https://passport.petcart.in/products',
      {headers: this.clientcredentialheader})
      .pipe(map(
      (response: Response) => {
        return response.json().data;
      })
      );
      }
      updateUserName(id, name, mobile, bio) {
        this.genAuthHeader();
        return this.http.put('https://passport.petcart.in/users/' + id,
        { name: name, mobile : mobile, bio: bio},
        {headers: this.authcredheader})
       .pipe(map(
         (response: Response) => {
           return response.json().data;
         })
       );
      }

      createOtp(uid, otp) {
        this.genAuthHeader();
        return this.http.put('https://passport.petcart.in/users/' + uid,
        {otp: otp},
        {headers: this.authcredheader})
       .pipe(map(
         (response: Response) => {
           return response.json().data;
         })
       );
      }
      verifyuser(uid) {
        this.genAuthHeader();
        return this.http.put('https://passport.petcart.in/users/' + uid,
        {verified: 'v'}, {headers: this.authcredheader})
       .pipe(map(
         (response: Response) => {
           return response.json().data;
         })
       );
      }
      sendOtp(name, mobile , otp) {
        const number = '+91' + mobile;
        const data = JSON.stringify({
          "externalUserId": "1",
          "textMessagingRequest": {
            "senderCode": "PetCrt",
            "recipient": number,
            "templatedTextMessagingRequest": {
              "templateName": "pcsms",
              "templateArgs": [
                name,
                otp
              ]
            }
          }
        });
       this.http.post('https://petcart.in:8085/v1/notifications/',
       data, {headers: new Headers({'Content-Type': 'application/json'})})
       .subscribe(
         (response: Response) => {
         }
       );
      }
      updateimage(id, image) {
        this.genAuthHeader();
        return this.http.put('https://passport.petcart.in/users/' + id,
      {image: image}, {headers: this.authcredheader})
      .pipe(map(
        (response: Response) => {
          return response.json().data;
        })
      );
      }

      updateUserMobile(id, mobile) {
        this.genAuthHeader();
        return this.http.put('https://passport.petcart.in/users/' + id,
        { mobile: mobile}, {headers: this.authcredheader})
       .pipe(map(
         (response: Response) => {
           return response.json().data;
         })
       );
      }

      getParticularUser(id): Observable<any> {
        this.genAuthHeader();
        return this.http.get('https://passport.petcart.in/users?id=' + id,
        {headers: this.authcredheader})
        .pipe(map(
        (response: Response) => {
          return response.json().data;
        })
        );
        }
        getParticularDummyUser(id): Observable<any> {
          this.genAuthHeader();
          return this.http.get('https://passport.petcart.in/dummyusers?user_id=' + id,
          {headers: this.authcredheader})
          .pipe(map(
          (response: Response) => {
            return response.json().data;
          })
          );
          }



        updateBillAdd(id, add_l1, add_l2, city_id, state_id, country_id, pin, phone, lat , lon) {
          this.genAuthHeader();
          return this.http.put('https://passport.petcart.in/billingadd/' + id  ,
          { add_l1: add_l1, add_l2: add_l2, city_id: city_id, state_id: state_id, country_id: country_id,
            pin: pin, phone: phone, lat: lat, lon: lon},
            {headers: this.authcredheader})
         .pipe(map(
           (response: Response) => {
             return response.json().data;

            }) 
          );
        }

        updateShipAdd(id, add_l1, add_l2, city_id, state_id, country_id, pin, phone, lat, lon) {
          this.genAuthHeader();
          return this.http.put('https://passport.petcart.in/shippingadd/' + id ,
          { add_l1: add_l1, add_l2: add_l2, city_id: city_id, state_id: state_id, country_id: country_id,
             pin: pin, phone: phone, lat: lat, lon: lon},
             {headers: this.authcredheader})
         .pipe(map(
           (response: Response) => {
             return response.json().data;
           })
         );
        }
        getuserId() {
          if (isPlatformBrowser(this.platformId)) {
          this.gdata = localStorage.getItem('currentUser');
          this.gjson = JSON.parse(this.gdata);
          if(this.gjson != null){
            this.uid = this.gjson.uid;
            return this.uid;
          }
        }
        }
        getSearchdata() {
          return this.http.get('https://passport.petcart.in/search',
          {headers: this.clientcredentialheader})
          .pipe(map(
            (response: Response) => {
            return response.json().data;
            })
          );
        }
        getProductSearchdata() {
          const type = 'product';
          return this.http.get('https://passport.petcart.in/search?type=' + type,
          {headers: this.clientcredentialheader})
          .pipe(map(
            (response: Response) => {
            return response.json().data;
            })
          );
        }
        getDoctorSearchdata() {
          const type = 'doctor';
          return this.http.get('https://passport.petcart.in/search?type=' + type,
          {headers: this.clientcredentialheader})
          .pipe(map(
            (response: Response) => {
            return response.json().data;
            })
          );
        }
        getIpAddress() {
          return this.http.get('https://freegeoip.net/json/?callback',
          {headers: this.clientcredentialheader})
                .pipe(map(
                  (response: Response) => {
                    return response.json();
                })
              );
         }
       setActivatepath(flag) {
        if (isPlatformBrowser(this.platformId)) {
        localStorage.setItem('activatepath', JSON.stringify({ ap: flag }));
        }
       }
       getActivatepath() {
        if (isPlatformBrowser(this.platformId)) {
         let apvalue = 0;
        const gdata = localStorage.getItem('activatepath');
        const gjson = JSON.parse(gdata);
        if (gjson != null) {
           apvalue = gjson.ap;
        }
        return apvalue;
      }
       }
       createNewChannel(doctorId: String, uid, startTimeMs: Number, endTimeMs: Number) {
        return this.http.post(
          this.interserviceUrls.base + this.interserviceUrls.liveChannel,
          {
            status: 'Started',
            startTimeMs: startTimeMs,
            endTimeMs: endTimeMs,
            customerExternalId: uid,
            serviceProviderExternalId: doctorId
          }
        ).pipe(map(
          (response: Response) => {
           return response.json();
        })
      );
      }
      doctorScheduledChatAtThisTime(docuid) {
        return this.http.get('https://petcart.in:8085/v1/live-channels/?channelStatus=Scheduled&externalUserId=' + docuid)
        .pipe(map(
          (response: Response) => {
            return response.json();
          })
        );
      }
      doctorOnoingChatAtThisTime(docuid) {
        return this.http.get('https://petcart.in:8085/v1/live-channels/?channelStatus=Started&externalUserId=' + docuid)
        .pipe(map(
          (response: Response) => {
            return response.json();
          })
        );
      }
      getAppointmentmentUserDetail(sid) {
        this.genAuthHeader();
        return this.http.get('https://passport.petcart.in/users?id=' + sid,
        {headers: this.authcredheader})
    .pipe(map(
        (response: Response) => {
        return response.json().data;
        })
        );
    }
    createChatWithUs(uid, docid, date, stime, etime,
      chattype, amount, status, mitterChannelId , ip , source) {
        this.genAuthHeader();
        return this.http.post('https://passport.petcart.in/chats',
      {user_id: uid, serviceprovider_id: docid, date: date, start_time: stime, end_time: etime,
      type: chattype, fee: amount, paystatus: status, chat_id: mitterChannelId, ip: ip, source: source},
      {headers: this.authcredheader})
    .pipe(map(
        (response: Response) => {
        return response.json().data;
        })
      );
      }
      getPetcartchatdata(cid) {
        this.genAuthHeader();
        return this.http.get('https://passport.petcart.in/chats?chat_id=' + cid,
        {headers: this.authcredheader})
    .pipe(map(
        (response: Response) => {
        return response.json().data;
        })
        );
      }
      getServiceProviderDetail(sid) {
        return this.http.get('https://passport.petcart.in/serviceproviders?id=' + sid,
        {headers: this.clientcredentialheader})
    .pipe(map(
        (response: Response) => {
        return response.json().data;
        })
        );
    }

    postForgotpass(email){
      return this.http.post('https://passport.petcart.in/forgotpass',
      {email: email},
      {headers: this.clientcredentialheader})
    .pipe(map(
        (response: Response) => {
        return response.json().data;
        })
      );
    }
    setReminderWithUs(uid, date, subject, type, status){
      this.genAuthHeader();
      return this.http.post('https://passport.petcart.in/setreminder',
    {user_id: uid,  date: date, subject: subject, type: type,status: status},
    {headers: this.authcredheader})
  .pipe(map(
      (response: Response) => {
      return response.json().data;
      })
    );
    }

    postToken(uid, token){
      this.genAuthHeader();
      return this.http.post('https://passport.petcart.in/notification',
      {user_id: uid, notifytoken: token},
      {headers: this.authcredheader})
     .pipe(map(
        (response: Response) =>{
         return response.text();
        })
        );
    }



    postpromoform(name: string, email: string, mobile: string,
        noofpets: string, typeofpets: string, source: string){
          console.log("postform", name, email, mobile,noofpets, typeofpets, source);
          return this.http.post('https://passport.petcart.in/campaignregintration',
              {campaign_id:2, campaign_name: 'Preregistration', name:name,mobile:mobile,email:email,pet_type:typeofpets,no_of_pet:noofpets,source: source},

          {headers: this.clientcredentialheader})
              .pipe(map((response: Response) => {
                  return response.json().data;
          })
        );

    }
    getTime(){
      return this.http.get('https://passport.petcart.in/time',
          {headers: this.clientcredentialheader})
          .pipe(map(
            (response: Response) => {
             return response.json();
            })
            );
    }
  }
